import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { repiActions } from '../../../store/repiStore';
import ModalInner from '../../layoutItems/modalInner';

import '../repi.scss';

class RepiConsentPopup extends React.Component {
    render() {
        return (
            <ModalInner close={() => this.props.close()} title={this.props.translate("Repi.Search.Consent.Title")}>
                <div className="repi-modal-body">
                    <Translate id="Repi.Search.Consent.Body" data={{ report: this.props.reportName }} />
                </div>
                <div className="modal-inner-buttons">
                    <button className={classnames("bb-button is-primary gradient-1", { "is-square": localStorage.locales_button_style === "square" })}
                        onClick={() => this.props.close()}
                    >
                        <Translate id="Repi.Search.Consent.No" />
                    </button>
                    <button className={classnames("bb-button is-primary gradient-1", { "is-square": localStorage.locales_button_style === "square" })}
                        onClick={() => this.props.onConfirm()}>
                        <Translate id="Repi.Search.Consent.Yes" />
                    </button>
                </div>
            </ModalInner>
        )
    }
}

export default withLocalize(connect(
    state => state.repi,
    dispatch => bindActionCreators(repiActions, dispatch)
)(RepiConsentPopup));